export default __webpack_public_path__ + "static/closeHand-276bc38527c4a65ded6810aaa9ede209.png";